/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var sale = Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<h6><span>RRP</span></h6><span class="money">' + formatPrice(price) + '</span>';
    if (comparing) {

      res =
        '<h6><span>RRP</span></h6><del><span class="ais-hit--price-striked money"><span>' +
        formatPrice(compare_at_price) +
        '</span></span></del><span class="money price-col--sale"> ' +
        formatPrice(price) +
        '</span>';
      // res +=
      //   ' <span class="ais-hit--price-discount" style="font-weight: ' +
      //   Math.floor(discount_ratio * 10) * 100 +
      //   ';">-' +
      //   Math.floor(discount_ratio * 100) +
      //   '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this.inventory_available === true){
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
      }
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      if (this.product_type === 'Full Bottle') {
          return '/collections/bottles/products/' + this.handle + (addVariantId ? ('?variant=' + this.objectID) : '');
      } else if (this.product_type === 'Tasting Pack') {
          return '/collections/packs/products/' + this.handle + (addVariantId ? ('?variant=' + this.objectID) : '');
      } else if (this.product_type === 'Glassware' || this.product_type === 'Journal') {
          return '/collections/exclusives/products/' + this.handle + (addVariantId ? ('?variant=' + this.objectID) : '');
      } else {
        return '/products/' + this.handle + (addVariantId ? ('?variant=' + this.objectID) : '');
      }
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullHTMLDescription: function fullHTMLDescription() {
      if(this.body_html_safe){
        var res = this.body_html_safe.substring(0,50).concat('...');
        return res;
      }
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    fullStoreURL : function(){
      return window.location.origin;
    },
    fullHTMLTag: function fullHTMLTag() {
      var res = '';
      // if (this.inventory_available === false){
      //   res = '<li><span class="badge badge-sold">Sold Out</span></li>';
      // }
      this.collections.forEach(function(collection){
        if ( collection === 'sale'){
          //res = '<li><span class="badge badge-sale">Sale</span></li>';
        }else if ( collection === 'coming-soon'){
          res = '<span class="badge badge-coming"><span id="comingText">Coming</span><span id="soonText">Soon</span></span><!-- /.badge badge-coming-soon -->';
        }
        else if ( collection === 'ballot-open'){
          res = '<span class="badge badge-open"><span id="ballotText">Ballot</span><span id="openText">Open</span></span><!-- /.badge badge-ballot -->';
        }
        else if ( collection === 'bottle-in-a-gift-box' || collection === 'bottle-in-a-premium-gift-box'){
          res = '<span class="badge badge-box">Collector&#39;s Box</span>';
        }
      });

      //function rewritten to work with Smart collection
      /*
      this.tags.forEach(function(tag) {
        if( tag === 'badge-sale'){
          res = '<li><span class="badge badge-sale">Sale</span></li>';
        }
        else if(tag === 'badge-new'){
          res = '<li><span class="badge">New</span></li>';
        }
      }); */
        return res;
    },
    fullHTMLSoldout: function fullHTMLSoldout() {
      var res = '';
      if (this.inventory_available === false){
        res = '<h4 class="bedge-soldout">Sold Out</h4>';
      }
      this.collections.forEach(function(collection){
        if ( collection === 'sold-out-tag'){
          res = '<h4 class="bedge-soldout">Sold Out</h4>';
        }
      });
      return res;
    },
    fullHTMLDiscountTag: function fullHTMLDiscountTag() {
      var res = '';
      this.collections.forEach(function(collection){
        if ( collection === 'discontinued'){
          res = '<span class="badge-discontinued badge-discontinued--item">Discontinued</span>'
        }
      });
      //function rewritten to work with Smart collection
      /*
      this.tags.forEach(function(tag) {
        if( tag === 'badge-discontinued'){
          res = '<span class="badge-discontinued">Discontinued</span>'
        }
       });
       */
      return res;
    },
    fullHTMLSale: function fullHTMLsale() {
      var res = '';
      var comparing = Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price);
      var sale = Number(this.compare_at_price) > Number(this.price);
      if (sale) {
      res = '<li><span class="badge badge-sale">Sale</span></li>';
      }
      return res;
    },
    fullHTMLMembersPriceTag: function fullHTMLMembersPriceTag() {
      var res = '';
       var no_advanced_discount = false;
       var advanced_subscribers_price = false;
       var elem = document.getElementById('member-details');
       var customer_logged_in = elem.getAttribute('data-customer-logged-in');
       var customer_data_title = elem.getAttribute('data-title');
       if (this.inventory_available === true){
        if( this.named_tags.memberprice ){
          if(customer_logged_in === 'yes' && this.product_type === 'Full Bottle'){
            customer.tags.forEach(function(tag) {
              // console.log('test-area----',tag);
            if(tag === 'Active Subscriber Advanced') {
                advanced_subscribers_price = true;
              }
            });
          }

          this.tags.forEach(function(tag) {
            // console.log(tag);
            if( tag === 'no-advanced-discount'){
              no_advanced_discount = true;
            }
          });

          var comparing = Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price);
          if( advanced_subscribers_price && no_advanced_discount == false){
            var memberNoPrice = document.getElementById('member-no-price');
            var current_members_price = memberNoPrice.getAttribute('data-no-member-price');
          }else{
            try {
              var current_members_price = this.named_tags.memberprice.replace("%", "").replace(" ", ""); // code that may throw an error if memberprice: not defined
            } catch (error) {
                console.error(error);
                var current_members_price = 0;
            }
          }

          if(comparing){
            //var current_price = Number(this.compare_at_price);
            var current_price = Number(this.price);
          }else{
            var current_price = Number(this.price);
          }
          var calculate_1 = (current_price * current_members_price) / 100 ;
          var calculate_2 =  current_price - calculate_1 ;
          res = '<div class="price-col--member price-col">'+
                '<h6>' + customer_data_title +
                '<span class="wrapper-tooltip">'+'<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">'+
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.1113 11.6558C9.19037 12.2712 8.10767 12.5996 7.0001 12.5996C5.5154 12.5979 4.092 12.0074 3.04216 10.9576C1.99232 9.90772 1.40178 8.4843 1.4001 6.99961C1.4001 5.89203 1.72853 4.80933 2.34387 3.88842C2.95921 2.9675 3.83381 2.24974 4.85707 1.82589C5.88034 1.40204 7.00631 1.29114 8.09261 1.50721C9.1789 1.72329 10.1767 2.25662 10.9599 3.0398C11.7431 3.82297 12.2764 4.82081 12.4925 5.9071C12.7086 6.9934 12.5977 8.11938 12.1738 9.14264C11.75 10.1659 11.0322 11.0405 10.1113 11.6558ZM9.68704 2.97831C8.89171 2.44688 7.95664 2.16324 7.0001 2.16324C5.71741 2.16324 4.48727 2.67278 3.58027 3.57978C2.67328 4.48677 2.16374 5.71693 2.16373 6.99961C2.16373 7.95615 2.44739 8.8912 2.97881 9.68654C3.51024 10.4819 4.26557 11.1018 5.1493 11.4678C6.03303 11.8339 7.00546 11.9296 7.94363 11.743C8.88179 11.5564 9.74354 11.0958 10.4199 10.4194C11.0963 9.74306 11.5569 8.88129 11.7435 7.94312C11.9301 7.00496 11.8344 6.03254 11.4683 5.14881C11.1023 4.26508 10.4824 3.50973 9.68704 2.97831ZM7.08495 10.2662C7.18621 10.2662 7.28333 10.226 7.35493 10.1544C7.42654 10.0828 7.46677 9.98568 7.46677 9.88441L7.46677 5.81169C7.46677 5.71042 7.42654 5.61333 7.35493 5.54173C7.28333 5.47012 7.18621 5.42987 7.08495 5.42987C6.98368 5.42987 6.88657 5.47012 6.81496 5.54173C6.74336 5.61333 6.70313 5.71042 6.70313 5.81169L6.70313 9.88441C6.70313 9.98568 6.74336 10.0828 6.81496 10.1544C6.88657 10.226 6.98368 10.2662 7.08495 10.2662ZM7.08495 4.53896C7.16046 4.53896 7.23429 4.51659 7.29708 4.47464C7.35987 4.43268 7.4088 4.37301 7.4377 4.30324C7.4666 4.23347 7.47416 4.15669 7.45943 4.08263C7.4447 4.00856 7.40833 3.94058 7.35493 3.88718C7.30153 3.83378 7.2335 3.79739 7.15944 3.78265C7.08537 3.76792 7.0086 3.77551 6.93883 3.8044C6.86907 3.8333 6.80943 3.88225 6.76748 3.94504C6.72552 4.00783 6.70313 4.08162 6.70313 4.15714C6.70313 4.2584 6.74336 4.35549 6.81496 4.4271C6.88657 4.4987 6.98368 4.53896 7.08495 4.53896Z" fill="#DBB27D"/>'+
                '</svg>'+'<div class="tooltip">'+
                '<div class="tooltip-content">'+'<div class="tp-subtitle">Member price</div>'+
                '<div class="tp-content"><p>Becoming a Liquor Loot subscriber means you get members pricing on a huge range of full bottles. <a href="/pages/subscription" title="Subscription">Learn more!</a></p><p></p><p>Already a member? <a href="/account/login" title="Login">Login</a></p></div>'+
                '</div>'+'</span>'+ '</h6>'+
                '<span class="money">'+ formatPrice(calculate_2) +'</span>'+
                '</div>';
        }
      }
      return res;
    },

    fullHTMLMetaInfo: function fullHTMLMetaInfo(){
      var res = '';
      if(this.meta.content_nose){
        formatStringDisplay(this.meta.content_nose, this.meta.content_nose.content_nose, "Nose");

        res =   res
        return res;
      }
      /* Function that check if the meta returns a string starting by "[" to fix bugged outputs */
      function formatStringDisplay(contentObject, contentObjectMeta, contentName){
        if(contentObjectMeta){
          if(contentObjectMeta.startsWith('[')){
            contentObjectMeta = contentObjectMeta.substring(2, contentObjectMeta.length-2);
          }
          res += '<div class="product-info-short__row"><h6>' + contentName + '</h6><p>' + contentObjectMeta + '</p></div>';
        }
      }
    },
    fullHTMLMetaInfoTaste: function fullHTMLMetaInfoTaste(){
      var res = '';
      if(this.meta.content_taste){
        formatStringDisplay(this.meta.content_taste, this.meta.content_taste.content_taste, "Taste");

        res = res
        return res;
      }
      /* Function that check if the meta returns a string starting by "[" to fix bugged outputs */
      function formatStringDisplay(contentObject, contentObjectMeta, contentName){
        if(contentObjectMeta){
          if(contentObjectMeta.startsWith('[')){
            contentObjectMeta = contentObjectMeta.substring(2, contentObjectMeta.length-2);
          }
          res += '<div class="product-info-short__row"><h6>' + contentName + '</h6><p>' + contentObjectMeta + '</p></div>';
        }
      }
    },
    fullHTMLMetaInfoFinish: function fullHTMLMetaInfoFinish(){
      var res = '';
      if(this.meta.content_finish){
        formatStringDisplay(this.meta.content_finish, this.meta.content_finish.content_finish, "Finish");

        //res = '<div class="product-info-short product-item__info">' + res + '</div>'
        return res;
      }
      /* Function that check if the meta returns a string starting by "[" to fix bugged outputs */
      function formatStringDisplay(contentObject, contentObjectMeta, contentName){
        if(contentObjectMeta){
          if(contentObjectMeta.startsWith('[')){
            contentObjectMeta = contentObjectMeta.substring(2, contentObjectMeta.length-2);
          }
          res += '<div class="product-info-short__row"><h6>' + contentName + '</h6><p>' + contentObjectMeta + '</p></div>';
        }
      }
    },
    fullOkendoReview: function fullOkendoReview(){
        var res = '';
        if(this.meta.okendo){
          res +=  '<div data-oke-reviews-product-listing-rating>' + this.meta.okendo.ProductListingSnippet + '</div>';
        }
        return res;
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);